import React from 'react';
import { connect } from 'react-redux';

const UnderConstruction = ({ i18n }) => {
  const { translations = {}, locale } = i18n || {};
  const t = translations[locale] || {};
  return <div className="align--hvc">{t.under_construction.text}</div>;
};

const mapStateToProps = state => ({
  i18n: state.i18n,
});

const connectStore = connect(mapStateToProps, null, null, {
  pure: true,
})(UnderConstruction);

export { UnderConstruction as UnderConstructionComponent }; // <- For component Unit Test
export default connectStore;
